import { CSSProperties } from "react"
import "./index.css"
import { ReactComponent as BackSvg } from "../../svg/back.svg"


/**
 * 
 * @param {{style:CSSProperties,showBottomLine:boolean,title:any,rightIcon:any}} param0 
 * @returns 
 */
const InnerHeader = ({ style, title, showBottomLine, onBack, rightIcon }) => {
    
    return <div className={`header   ${showBottomLine === true ? 'bottom-line' : ''}`} style={{ maxWidth:"100%",overflow:"hidden", marginLeft:"0.12rem",...style, }}>
        <div className='' style={{ paddingTop: "0.02rem", paddingBottom: ".04rem" ,display:"flex",flexDirection:"row",alignItems:'center',justifyContent:'start'}}  >
            <div className='header-left btn' onClick={() => onBack ? onBack?.() : window.history.back()}>
                < BackSvg style={{width:"0.25rem"}} />
            </div>
            <div  style={{ fontWeight: 'bold', color: "#000D20" ,textAlign:"center", width:"80%", fontSize:"0.18rem"}}>{title}</div>
            <div className='header-right'>{rightIcon}</div>
        </div>
    </div>
}

export default InnerHeader